import { render, staticRenderFns } from "./address-dialog.vue?vue&type=template&id=1cab312b&scoped=true"
import script from "./address-dialog.vue?vue&type=script&lang=js"
export * from "./address-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab312b",
  null
  
)

export default component.exports